import {createAction, props} from '@ngrx/store';
import {ApproveExportConfigResponseDTO} from '../../../../../openapi/export-openapi';


export class DatevWizardLoginActions {

  private static readonly prefix = '[Datev Wizard Login]';

  /**
   * Initialisiert den Login-Prozess beim Component-Init
   * Prüft Route- und Query-Parameter
   */
  public static initializeLogin = createAction(
    `${this.prefix} Initialize Login`
  );

  /**
   * Verarbeitet den OAuth2-Callback von DATEV
   */
  public static login = createAction(
    `${this.prefix} Process DATEV Login`,
    props<{
      code: string,
      state: string,
      sessionState: string,
    }>()
  );

  /**
   * OAuth2-Callback wurde erfolgreich verarbeitet
   */
  public static loginSuccess = createAction(
    `${this.prefix} Process DATEV Login Success`,
    props<{
      response: ApproveExportConfigResponseDTO,
    }>()
  );

  /**
   * Fehler beim Verarbeiten des OAuth2-Callbacks
   */
  public static loginFailure = createAction(
    `${this.prefix} Process DATEV Callback Failure`,
    props<{
      error: any,
    }>()
  );

  /**
   * OAuth2-Fehler vom DATEV-Server (z.B. access_denied)
   * Wird dispatcht, wenn DATEV mit error und error_description zurück redirected
   */
  public static oauthError = createAction(
    `${this.prefix} OAuth Error from DATEV`,
    props<{
      errorCode: string,
      errorDescription: string,
      state: string,
    }>()
  );

  /**
   * Navigiert zur parametrisierten Route um Query-Parameter zu entfernen
   */
  public static goToParameterizedRoute = createAction(
    `${this.prefix} Go to Parameterized Route`,
    props<{
      code: string,
      state: string,
      sessionState: string,
    }>()
  );

  /**
   * Navigiert zur parametrisierten Error-Route um Query-Parameter zu entfernen
   * Wird verwendet wenn DATEV mit error & error_description zurück redirected
   */
  public static goToParameterizedErrorRoute = createAction(
    `${this.prefix} Go to Parameterized Error Route`,
    props<{
      errorCode: string,
      errorDescription: string,
      state: string,
    }>()
  );

  /**
   * Navigiert zum Wizard-Start
   */
  public static goToWizardStart = createAction(
    `${this.prefix} Go to Wizard Start`
  );

  /**
   * Navigiert zur config-details Seite nach erfolgreichem Login
   */
  public static navigateToConfigDetails = createAction(
    `${this.prefix} Navigate to Config Details`,
    props<{
      exportConfigId: string,
    }>()
  );

  /**
   * Retry: Navigiert zurück zur gespeicherten URL
   * Wird vom Retry-Button im Error-UI aufgerufen
   */
  public static retry = createAction(
    `${this.prefix} Retry`
  );

}
